import baartLogo from '../../images/baart-logo.svg';

const brand = '#414141';

export default {
  brand: brand,
  brandImage: baartLogo,

  borderRadius: '4px',

  btnDefaultBg: 'white',
  btnDefaultColor: '#666666',

  btnPrimaryBg: '#CCCCCC',
  btnPrimaryColor: '#000000',

  btnSecondaryBg: '#EFF0F1',
  btnSecondaryColor: brand,

  error: {
    bg1: '#FAE6E6',
    bg2: '#F2D8D8',
    border: '#CF9999',
    color: '#9C4343'
  },

  headerBg: brand,
  headerColor: 'white',
  headerHeight: '50px',

  input: {
    bg: '#FFFFFF',
    border: '#CCCCCC',
    borderRadius: '8px',
    color: '#666666',
    error: {
      border: '#A82222',
      color: '#A82222'
    },
    placeholder: '#CCCCCC',
    warning: {
      border: '#8A6D3B',
      color: '#8A6D3B'
    }
  },

  lightBg1: '#EFF0F1',
  lightBg2: '#E3E4E6',

  maxWidth: '380px',

  notice: {
    bg1: '#EDF6FF',
    bg2: '#E2EFFB',
    border: '#A5BDD4',
    color: '#2E5A82'
  },

  sectionBg1: '#414141',
  sectionBg2: '#313131',

  submitButtonBg: brand,
  submitButtonColor: 'white',
  submitButtonDisabledColor: brand,
  submitButtonHeight: '50px',

  text: {
    dark: brand,
    light: '#999999',
    normal: '#666666'
  },

  warning: {
    bg1: '#FFFDF7',
    bg2: '#FAF2D9',
    border: '#D9D1B9',
    color: '#5C5B53'
  }
};



// WEBPACK FOOTER //
// ./src/config/themes/baart.js